const appUpdate = {
  namespaced: true,
  state: {
    showUpdateModal: false, // 是否显示更新详情弹窗
    showUpdateTip: false, // 是否显示更新提示
    downloaded: false, // 是否下载完成
  },
  getters: {
    showUpdateModal: (state) => state.showUpdateModal,
    showUpdateTip: (state) => state.showUpdateTip,
    downloaded: (state) => state.downloaded,
  },
  mutations: {
    setShowUpdateModal(state, showUpdateModal) {
      state.showUpdateModal = showUpdateModal
    },
    setShowUpdateTip(state, showUpdateTip) {
      state.showUpdateTip = showUpdateTip
    },
    setDownloaded(state, downloaded) {
      state.downloaded = downloaded
    },
  },
  actions: {
    setShowUpdateModal({ commit }, showUpdateModal) {
      commit('setShowUpdateModal', showUpdateModal)
    },
    setShowUpdateTip({ commit }, showUpdateTip) {
      commit('setShowUpdateTip', showUpdateTip)
    },
    setDownloaded({ commit, state }, downloaded) {
      commit('setDownloaded', downloaded)
      commit('setShowUpdateTip', downloaded)
    },
  },
}

export default appUpdate
